"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../../config/constants"));
var actions_1 = require("../../../redux/reducers/draws/actions");
var framework_1 = require("../../../widgets/framework");
var styles_1 = require("../styles");
var EligibleGames = function (_a) {
    var promotionId = _a.promotionId, eligibleGames = _a.eligibleGames;
    var t = (0, react_i18next_1.useTranslation)().t;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.styles)(theme)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_1.useState)(false), showModal = _b[0], setShowModal = _b[1];
    (0, react_1.useEffect)(function () {
        if (promotionId) {
            dispatch((0, actions_1.fetchEligibleGames)(promotionId));
        }
    }, [promotionId]);
    var selectGame = function (game) { return __awaiter(void 0, void 0, void 0, function () {
        var appNavigate;
        return __generator(this, function (_a) {
            appNavigate = {
                action: 'GAME_DETAIL',
                data: game
            };
            framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
            return [2];
        });
    }); };
    var onModalOpen = function () {
        setShowModal(true);
    };
    var onModalClose = function () {
        setShowModal(false);
    };
    var filteredEligibleGames = eligibleGames
        ? eligibleGames.slice(0, constants_1.default.NUM_DRAW_ELIGIBLE_GAMES)
        : [];
    if (!filteredEligibleGames || filteredEligibleGames.length === 0)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(package_1.RelatedGamesDialog, { title: 'Eligible Games', relatedGames: eligibleGames, selectGame: selectGame, handleClose: onModalClose, openDialog: showModal }),
        react_1.default.createElement(core_1.Grid, { className: classes.eligibleGames, item: true, container: true, xs: 12, spacing: 4 },
            react_1.default.createElement(package_1.RelatedGames, { relatedGames: filteredEligibleGames, selectGame: selectGame, showRelatedGames: onModalOpen, title: t('drawDetails.relatedGamesTitle'), customShowAllEligibleGamesIcon: 'custom_open_in_new', customShowAllEligibleGamesIconProps: { width: 60, height: 30, viewBox: '0 0 60 30', fontSize: 'inherit' } }))));
};
exports.default = EligibleGames;
//# sourceMappingURL=EligibleGames.js.map